/**
 * Created by Josef Jurca on 14.5.2018.
 */

import {getInstance as getDataSources} from 'datasources';
import {getAssetById} from 'store/actions/asset';
import {LandingPageTypes} from 'models/landingpage';
import _ from 'lodash';
import {attemptSessionRefresh} from 'store/actions/session';
import {fetchLinearChannels} from 'store/actions/linearchannels';

// Action types
const ActionTypes = {
        SET_LANDING_PAGE: 'SET_LANDING_PAGE',
        SET_CURRENT_LANDING_PAGE: 'SET_CURRENT_LANDING_PAGE',
        LANDING_PAGE_SET_STATUS: 'LANDING_PAGE_SET_STATUS',
        LANDING_PAGE_SET_ERROR: 'LANDING_PAGE_SET_ERROR'
    },

    // Status values
    LandingPageStatuses = {
        INITIAL: 'initial',
        REQUEST_OPEN: 'request-open',
        REQUEST_FAILURE: 'request-failure',
        REQUEST_SUCCESS: 'request-success'
    };

/**
 * Creates and returns a set status action.
 *
 * @param {string} status - LP status.
 * @returns {Object} Set status action.
 */
function setStatus (status = LandingPageStatuses.INITIAL) {

    return {
        type: ActionTypes.LANDING_PAGE_SET_STATUS,
        status
    };
}

/**
 * Creates and returns a set error action.
 *
 * @param {string} error - Error.
 * @returns {Object} Set error action.
 */
function setError (error = '') {

    return {
        type: ActionTypes.LANDING_PAGE_SET_ERROR,
        error
    };
}

/**
 * Creates and returns a set landing page action.
 *
 * @param {Object} landingPage - Landing page.
 * @returns {Object} Set linear channels action.
 */
function setLandingPage (landingPage) {
    return {
        type: ActionTypes.SET_LANDING_PAGE,
        landingPage
    };
}

/**
 * Creates and returns a set current landing page action.
 *
 * @param {Object} currentLandingPage - Landing page.
 * @returns {Object} Set linear channels action.
 */
function setCurrentLandingPage (currentLandingPage) {
    return {
        type: ActionTypes.SET_CURRENT_LANDING_PAGE,
        currentLandingPage
    };
}



/**
 * Creates and returns a load landing page action.
 *
 * @returns {Function} Dispatch function.
 */
function loadLandingPage () {
    return (dispatch, getState) => {
        let dataSources = getDataSources(),
            landingPage,
            wasSessionUpdated = _.get(getState(), ['session', 'wasUpdated']);

        dispatch(setStatus(LandingPageStatuses.REQUEST_OPEN));

        return dataSources.getConfig().then(config => {
            return dataSources.getLandingPage(_.get(config, ['_presets', 'landingPageConfigUrl']));
        }).then((landing) => {
            landingPage = landing;
            if (!wasSessionUpdated) {
                return dispatch(attemptSessionRefresh(false, true));
            } 
                return Promise.resolve();

        }).then(() => {

            let currentLandingPage = landingPage.getCurrentLandingPage(),
                assetPromise;

            localStorage['isLanding'] = true;
            
            dispatch(setLandingPage(landingPage));
            dispatch(setCurrentLandingPage(currentLandingPage));
            if (currentLandingPage.type !== LandingPageTypes.general) {
                assetPromise = dispatch(getAssetById(currentLandingPage.assetId,
                    'assetReferenceType=' + currentLandingPage.assetReferenceType));
            } else {
                assetPromise = Promise.resolve();
            }

            return assetPromise;

        }).then(() => {

            // dispatch(fetchLinearChannels());

            dispatch(setStatus(LandingPageStatuses.REQUEST_SUCCESS));
        }).catch(error => {
            dispatch(setError(error));
            dispatch(setStatus(LandingPageStatuses.REQUEST_FAILURE));
        });
    };
}

export {
    ActionTypes,
    LandingPageStatuses,
    loadLandingPage
};


// WEBPACK FOOTER //
// ./src/js/store/actions/landing.js